import { retryDynamicImport } from "@shared/lib"
import { hedera, transactionDetails, transfers } from "@shared/routes"
import { RouteObject } from "react-router-dom"

export default [
	{
		path: transfers,
		children: [
			{
				path: transactionDetails,
				lazy: () =>
					retryDynamicImport(
						() => import("../transaction-details"),
					).then(m => ({
						Component: m.TransactionDetailsPage,
					})),
			},
		],
	},
	{
		path: hedera,
		children: [
			{
				index: true,
				lazy: () =>
					retryDynamicImport(() => import("../hedera")).then(m => ({
						Component: m.HederaPage,
					})),
			},
		],
	},
] satisfies RouteObject[]
